export const rankingResaleReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_PROJECT_RESALE_RANKING_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        projectResaleRankings: null,
      };
    }
    case "GET_PROJECT_RESALE_RANKING_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        projectResaleRankings: action.payload,
      };
    }
    case "GET_PROJECT_RESALE_RANKING_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        projectRankings: action.payload,
      };
    }
    case "UPDATE_PROJECT_RESALE_RANKING_REQUEST": {
      return {
        ...state,
        loading: true,
        projectResaleRankings: null,
      };
    }
    case "UPDATE_PROJECT_RESALE_RANKING_SUCCESS": {
      return {
        ...state,
        loading: false,
        projectResaleRankings: action.payload,
      };
    }
    case "UPDATE_PROJECT_RESALE_RANKING_FAILED": {
      return {
        ...state,
        loading: false,
        projectResaleRankings: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
